module.exports = __webpack_public_path__ + "img/banners.742857ae.png";